import axios from 'axios';
import Environment from '../../utils/Environment';

export type FieldType = 'string' | 'number' | 'date' | 'boolean';

export interface FieldTypeInfo {
  fieldName: string;
  fieldType: FieldType;
}

interface FieldTypesResponse {
  fieldTypes: { [fieldName: string]: FieldType } | FieldTypeInfo[];
}

const getFieldTypeForTable = async (
  orgCode: string,
  env: string,
  group: string,
  subGroup: string
): Promise<{ [fieldName: string]: FieldType }> => {
  try {
    const baseURL = Environment.getFieldTypeAPI();
    
    if (!baseURL) {
      console.warn('⚠️ Field type API URL not configured');
      return {};
    }
    
    if (!orgCode || !group || !subGroup) {
      console.warn('⚠️ Missing required parameters for field type API');
      return {};
    }
    
    const response = await axios.get<FieldTypesResponse>(baseURL, {
      params: {
        dcCode: orgCode,
        group,
        sub: subGroup
      }
    });
    
   
    // Handle different response formats
    if (response.data) {
      // If response has fieldTypes property and it's an object
      if (response.data.fieldTypes && typeof response.data.fieldTypes === 'object' && !Array.isArray(response.data.fieldTypes)) {
        return response.data.fieldTypes;
      }
      
      // If response has fieldTypes property and it's an array
      if (response.data.fieldTypes && Array.isArray(response.data.fieldTypes)) {
        const fieldTypeMap: { [fieldName: string]: FieldType } = {};
        response.data.fieldTypes.forEach((item: FieldTypeInfo) => {
          fieldTypeMap[item.fieldName] = item.fieldType;
        });
       return fieldTypeMap;
      }
      
      // If response is directly an object with field names as keys
      if (typeof response.data === 'object' && !Array.isArray(response.data) && !response.data.fieldTypes) {
        return response.data as unknown as { [fieldName: string]: FieldType };
      }
    }
    
    console.warn('⚠️ Unexpected response format, returning empty object');
    return {};
  } catch (err: any) {
    console.error('❌ Error fetching field types:', err.message || err);
    if (err.response) {
      console.error('Response status:', err.response.status);
      console.error('Response data:', err.response.data);
    }
    return {};
  }
};

export default getFieldTypeForTable;
